module.exports = __webpack_public_path__ + "img/login.76c86ff4.jpg";